"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validations_1 = require("../../utils/validations");
function updateQuizModuleWorstMark({ worstModuleMark: existingWorstModuleMarks }, { mark }) {
    if (!(0, validations_1.isNumber)(existingWorstModuleMarks)) {
        return mark;
    }
    return Math.min(mark, existingWorstModuleMarks);
}
exports.default = updateQuizModuleWorstMark;
